import { render, staticRenderFns } from "./TheEventList.vue?vue&type=template&id=5688d8e2&scoped=true"
import script from "./TheEventList.vue?vue&type=script&lang=js"
export * from "./TheEventList.vue?vue&type=script&lang=js"
import style0 from "./TheEventList.vue?vue&type=style&index=0&id=5688d8e2&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5688d8e2",
  null
  
)

export default component.exports